var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4,20.42c1.11,2.62,1.92,5.34,2.84,8.02.29.85-.07,1.6-.66,2.22-.61.65-1.22,1.31-1.88,1.91-.75.67-.85,1.32-.37,2.25,2.49,4.84,6.32,8.28,10.99,10.9.76.43,1.37.29,1.96-.33.64-.68,1.31-1.33,1.98-1.98.66-.63,1.47-.98,2.34-.66,2.66.96,5.41,1.69,8,2.87,1.27,1.7,1.24,4.05-.08,5.73-.68.87-1.54,1.54-2.4,2.21-.17.12-.34.23-.5.35,0,0,0-.03,0-.03-3.88,1.81-7.69,1.38-11.35-.53-8.22-4.3-14.61-10.47-18.73-18.86-1.83-3.73-2.28-7.51-.27-11.35.74-1.07,1.51-2.11,2.6-2.86,1.68-1.16,3.98-1.1,5.53.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.23,42.2c-1.4-.09-1.66-.35-1.65-1.8.06-9.8-6.56-18.7-16.31-21.28-1.89-.5-3.81-.77-5.77-.71-1.14.03-1.8-.4-1.67-1.65.98-1.24,2.34-.75,3.52-.65,5.54.48,10.45,2.53,14.58,6.3,4.43,4.04,6.98,9.1,7.78,15.03.14,1.04.16,2.1.23,3.15.05.66-.18,1.19-.71,1.59Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75,21.94c8.38.12,15.35,6.6,16.15,15,.05.57.13,1.13.13,1.7,0,.77-.27,1.39-1.18,1.38-.89-.01-1.18-.59-1.16-1.39.06-2.33-.44-4.54-1.53-6.58-2.61-4.88-6.69-7.48-12.24-7.75-.08,0-.16-.01-.24,0-.88.02-1.76-.13-1.73-1.21.03-1.08.94-1.17,1.8-1.15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5,27.97c4.74.12,8.61,4.19,8.53,8.78-.01.81-.26,1.43-1.11,1.44-.77,0-1.06-.55-1.13-1.31-.42-4.2-2.49-6.25-6.69-6.66-.76-.07-1.32-.4-1.27-1.17.07-1.13.97-1.12,1.68-1.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.380591e99d2f008101580e85b70d55db.svg";
export { ForwardRef as ReactComponent };